<template>
  <v-app id="inspire">
    <v-app id="login">
      <v-main>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="4"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="primary"
                  dark
                  flat
                >
                  <v-toolbar-title>Login-- IGREEN</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      v-model="formLabelAlign.url"
                      label="雲端服務"
                      prepend-icon="mdi-account"
                      type="text"
                    />

                    <v-text-field
                      v-model="formLabelAlign.cust_id"
                      label="客戶編號"
                      prepend-icon="mdi-account"
                      type="text"
                    />

                    <v-text-field
                      v-model="formLabelAlign.uid"
                      label="帳號"
                      prepend-icon="mdi-account"
                      type="text"
                    />

                    <v-text-field
                      id="password"
                      v-model="formLabelAlign.password"
                      label="密碼"
                      prepend-icon="mdi-lock"
                      type="password"
                    />

                    <canvas
                      id="auth-code"
                      @click="genCode"
                    />

                    <v-text-field
                      v-model="number"
                      label="驗證碼"
                      type="text"
                      @keyup.enter="onLogin"
                    />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="onLogin"
                  >
                    登入
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
      <v-footer
        color="indigo"
        app
      >
        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>

      <v-snackbar
        v-model="snackbar"
        top
        :color="snackbarcolor"
        multi-line="multi-line"
        timeout="2000"
      >
        {{ text }}
        <template #action="{ attrs }">
          <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-app>
  </v-app>
</template>

<script>
import Cookies from "js-cookie";
var md5 = require("md5");
import moment from "moment";
var randomstring = require("randomstring");

export default {
  name: "Login",
  data() {
    return {
      securityCode: "456465",
      snackbar: "",
      text: "",
      snackbarcolor: "",
      number: "",
      formLabelAlign: {
        // uid: "admintest", //"cncdemo",
        // password: "123456",
        // url: "demo.igreent.com",
        // cust_id: "demo",
        uid: "",
        password: "",
        url: "",
        cust_id: "",
      },
      pwrules: {
        account: [{ required: true, message: "", trigger: "blur" }],
        email: [{ required: true, message: "", trigger: "blur" }],
      },
      items: [],
    };
  },
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
  },
  created: function () {
    let that = this;
    window.setTimeout(function () {
      that.securityCode = randomstring.generate({
        length: 4,
        charset: "numeric",
      });

      that.genCode();

      if (Cookies.get("form") != null) {
        that.number = that.securityCode;
        that.formLabelAlign = JSON.parse(Cookies.get("form"));
        that.onLogin();
      }
    }, 1000);

    if (Cookies.get("cust_id") != null) {
      this.formLabelAlign.cust_id = Cookies.get("cust_id");
    }

    if (Cookies.get("curl") != null) {
      this.formLabelAlign.url = Cookies.get("curl");
    }

    // if (Cookies.get("form") != null) {
    //   this.formLabelAlign = JSON.parse(Cookies.get("form"));
    //   this.onLogin();
    // }
  },
  methods: {
    genCode() {
      // console.log("a");
      let that = this;
      that.securityCode = randomstring.generate({
        length: 4,
        charset: "numeric",
      });
      let options = {
        canvasId: "auth-code",
        txt: that.securityCode,
        height: 50,
        width: 200,
      };
      that.writeAuthCode(options);
    },
    writeAuthCode(options) {
      let canvas = document.getElementById(options.canvasId);
      canvas.width = options.width || 300;
      canvas.height = options.height || 150;
      let ctx = canvas.getContext("2d");
      ctx.textBaseline = "middle";
      ctx.fillStyle = this.randomColor(180, 255);
      ctx.fillRect(0, 0, options.width, options.height);

      for (let i = 0; i < options.txt.length; i++) {
        let txt = options.txt.charAt(i);
        ctx.font = "20px SimHei";
        ctx.fillStyle = this.randomColor(50, 160);
        ctx.shadowOffsetY = this.randomNum(-3, 3);
        ctx.shadowBlur = this.randomNum(-3, 3);
        ctx.shadowColor = "rgba(0, 0, 0, 0.3)";
        let x = (options.width / (options.txt.length + 1)) * (i + 1);
        let y = options.height / 2;
        let deg = this.randomNum(-30, 30);
        ctx.translate(x, y);
        ctx.rotate((deg * Math.PI) / 180);
        ctx.fillText(txt, 0, 0);
        ctx.rotate((-deg * Math.PI) / 180);
        ctx.translate(-x, -y);
      }

      for (let i = 0; i < this.randomNum(1, 4); i++) {
        ctx.strokeStyle = this.randomColor(40, 180);
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, options.width),
          this.randomNum(0, options.height)
        );
        ctx.lineTo(
          this.randomNum(0, options.width),
          this.randomNum(0, options.height)
        );
        ctx.stroke();
      }

      for (let i = 0; i < options.width / 6; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          this.randomNum(0, options.width),
          this.randomNum(0, options.height),
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    randomColor(min, max) {
      let r = this.randomNum(min, max);
      let g = this.randomNum(min, max);
      let b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    loginok(response) {
      let uid = response.uid;
      this.$store.commit("setLoginInfo", response);
      Cookies.set("info", response);
      Cookies.set("Accountid", uid);
      // console.log("loginok",this.loginUID)

      if (this.loginUID.superuser == "0") {
        this.items = [
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },
          { icon: "mdi-view-dashboard", text: "即時監控(參數)", href: "Home" },
          { icon: "mdi-chart-pie", text: "即時監控(圖形)", href: "Dashboard" },
          { icon: "mdi-database", text: "數據分析", href: "Analysis" },
        ];
      } else if (this.loginUID.superuser == "1") {
        this.items = [
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },
          { icon: "mdi-view-dashboard", text: "即時監控(參數)", href: "Home" },
          { icon: "mdi-chart-pie", text: "即時監控(圖形)", href: "Dashboard" },
          { icon: "mdi-database", text: "數據分析", href: "Analysis" },
          {
            icon: "mdi-chevron-up",
            "icon-alt": "mdi-chevron-down",
            text: "系統管理",
            model: false,
            children: [
              { text: "帳號管理", icon: "mdi-account", href: "AccountList" },
              { text: "基本資料", icon: "mdi-account", href: "Account" },
              {
                text: "現場設備圖控設定",
                icon: "mdi-account",
                href: "MapEdit",
              },
            ],
          },
        ];
      } else if (this.loginUID.superuser == "3") {
        this.items = [
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },
          {
            text: "CNC設備監控管理",
            icon: "fa-tachometer-alt",
            href: "ReportCNC",
          },
          {
            icon: "mdi-chevron-up",
            "icon-alt": "mdi-chevron-down",
            text: "系統管理",
            model: false,
            children: [
              { text: "帳號管理", icon: "mdi-account", href: "AccountList" },
              { text: "基本資料", icon: "mdi-account", href: "Account" },
            ],
          },
        ];
      } else if (this.loginUID.superuser == "4") {
        this.items = [
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },
          {
            text: "CNC設備監控管理",
            icon: "fa-tachometer-alt",
            href: "ReportCNC",
          },
          {
            icon: "mdi-chevron-up",
            "icon-alt": "mdi-chevron-down",
            text: "系統管理",
            model: false,
            children: [
              { text: "基本資料", icon: "mdi-account", href: "Account" },
            ],
          },
        ];
      } else if (this.loginUID.superuser == "5") {
        this.items = [
          {
            icon: "mdi-chart-pie",
            text: "太陽能監控系統",
            href: "solarDashboard",
          },
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },
          { icon: "mdi-view-dashboard", text: "即時監控(參數)", href: "Home" },
          { icon: "mdi-chart-pie", text: "即時監控(圖形)", href: "Dashboard" },

          { icon: "mdi-database", text: "數據分析", href: "Analysis" },
          {
            icon: "mdi-chevron-up",
            "icon-alt": "mdi-chevron-down",
            text: "系統管理",
            model: false,
            children: [
              { text: "帳號管理", icon: "mdi-account", href: "AccountList" },
              { text: "基本資料", icon: "mdi-account", href: "Account" },
              {
                text: "現場設備圖控設定",
                icon: "mdi-account",
                href: "MapEdit",
              },
            ],
          },
          // {
          //   text: "品質數據監控管理",
          //   icon: "fa-tachometer-alt",
          //   href: "ReportQu",
          // },
        ];
      } else if (this.loginUID.superuser == "6") {
        this.items = [
          {
            icon: "mdi-chart-pie",
            text: "太陽能監控系統",
            href: "solarDashboard",
          },
          { text: "設備狀態表", icon: "fa-list", href: "ReportStatus" },

          { icon: "mdi-view-dashboard", text: "即時監控(參數)", href: "Home" },
          { icon: "mdi-chart-pie", text: "即時監控(圖形)", href: "Dashboard" },
          { icon: "mdi-database", text: "數據分析", href: "Analysis" },
          // {
          //   text: "品質數據監控管理",
          //   icon: "fa-tachometer-alt",
          //   href: "ReportQu",
          // },
        ];
      }
      this.$store.commit("setMenu", this.items);
      let nform = {
        cust_id: this.loginInfo.cust_id,
        uid: uid,
        login_dat: moment().format("YYYY-MM-DD HH:mm:ss"),
      };
      this.$store
        .dispatch("exec_cust_uid_0061", nform)
        .then((res) => {
          //  console.log(res)
          if (Cookies.get("url") != null) {
            // console.log(" cookie",Cookies.get("url"))
            this.$router.push(Cookies.get("url"));
          } else {
             console.log("no cookie", this.loginUID.superuser)
            if (
              this.loginUID.superuser == "0" ||
              this.loginUID.superuser == "1" ||
              this.loginUID.superuser == "3" ||
              this.loginUID.superuser == "4"
            ) {
              this.$router.push("/ReportStatus");
            } else if(this.loginUID.superuser == "5" ||
              this.loginUID.superuser == "6" ){
              this.$router.push("/SolarDashboard");
            }else {
              this.$router.push("/Home");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onLogin() {
      let form = this.formLabelAlign;
      if (form.uid == "" || form.password == "") {
        alert("empty");
        return;
      }
      let that = this;

      if (this.securityCode != this.number)  {
           that.text = "驗證碼錯誤";
           that.snackbarcolor = "red";
           that.snackbar = true;
           return;
         }
   

      this.$store.dispatch("setHost", form.url);
      var json = JSON.stringify(form);
      Cookies.set("form", json);
      let md5pw = md5(form.password);
      let nform = {
        cust_id: form.cust_id,
        uid: form.uid,
      };

      this.$store
        .dispatch("getlogin", nform)
        .then((res) => {
          if (res != false) {
            res = res[0];
            if (res.psw == md5pw) {
              this.$store.commit("setLoginUID", res);
              this.loginok(form);
              Cookies.set("cust_id", form.cust_id);
          
              Cookies.set("curl", form.url);
            } else {
              that.text = "fail";
              that.snackbarcolor = "red";
              that.snackbar = true;
            }
          } else {
            that.text = "fail";
            that.snackbarcolor = "red";
            that.snackbar = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });

 
      if (form.uid == "admin" && form.password == "1234") {
          // this.loginok(form);
      }
    },
  },
};
</script>

<style scoped>
#login{
   background-image: url('../assets/bg1.jpg');
   /*background-color: rgb(35, 41, 36);*/
}
</style>